// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72e7e0c0","667":"0c1a5b96","977":"61479c04"}[chunkId] + ".chunk.js";
};